// tslint:disable:max-line-length
import { createAction, props } from '@ngrx/store';

export const LoadTickets = createAction('[Freshdesk] Load Tickets');
export const LoadTicketsSuccess = createAction('[Freshdesk] Load Tickets Success', props<{ tickets: { count: number; tickets: any[] } }>());
export const LoadTicketsFail = createAction('[Freshdesk] Load Tickets Fail', props<{ error: any }>());
